import React, { memo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Col, Image, Button, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Card from '../common/Card'
import { PlusIcon, SettingsIcon, TrashIcon, CheckCircleIcon } from '@/components/icons/new'

const PlatformCard = memo(({ className, img, header, connected, onConnect, onRevoke }) => {
    const params = useParams()
    const navigate = useNavigate()

    return (
        <Col>
            <Card className="platform-card">
                <Card.Body className={'text-center tw:flex tw:flex-col tw:items-center ' + className}>
                    <div className="platform-card-image">
                        <Image src={img} alt="01" className="img-fluid avatar-50 object-contain" />
                    </div>
                    <h5 className="my-4 counter">{header}</h5>
                    {connected ? (
                        <div className="tw:flex tw:items-center tw:gap-2">
                            {/* Connected status indicator */}
                            <div className="tw:flex tw:items-center tw:gap-1 text-green-500">
                                <CheckCircleIcon size={16} />
                                <span className="tw:text-sm tw:font-regular">Connected</span>
                            </div>
                            {/* Settings button */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Campaign Settings</Tooltip>}>
                                <button
                                    className="btn btn-sm btn-secondary btn-icon connected-action-btn color-white"
                                    onClick={() => navigate('/campaigns/edit/' + params.id)}
                                >
                                    <SettingsIcon size={20} color="white" />
                                </button>
                            </OverlayTrigger>
                            {/* Disconnect button */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Disconnect</Tooltip>}>
                                <button
                                    className="btn btn-sm btn-icon connected-action-btn connected-action-btn-danger"
                                    onClick={() => onRevoke()}
                                >
                                    <TrashIcon size={20} color="white" />
                                </button>
                            </OverlayTrigger>
                        </div>
                    ) : (
                        <Button
                            className="btn-primary d-flex align-items-center gap-1"
                            variant="primary"
                            size="sm"
                            onClick={() => onConnect()}
                        >
                            <PlusIcon />
                            <span className="btn-inner">Connect</span>
                        </Button>
                    )}
                </Card.Body>
            </Card>
        </Col>
    )
})

PlatformCard.displayName = 'PlatformCard'
export default PlatformCard
